import { render } from "./Index.vue?vue&type=template&id=0ca9141c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=0ca9141c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ca9141c"

export default script